import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';

import { Info } from 'common/images/FaIcons';
import colors from 'common/styles/colors';

// A compact, informational note meant to sit inline in a toolbar/header row
// (right-aligned, no background, no added vertical space). Pass an optional
// `detail` to show a longer explanation in a tooltip on the icon.
const NoteContainer = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  color: ${colors.darkGray};
  font-size: 0.8rem;
  line-height: 1.2;
  ${props => props.nowrap && 'white-space: nowrap;'}
  ${props => props.pill && `
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    background-color: ${colors.greyXXXL};
    border: 1px solid ${colors.borderGray};
  `}

  svg {
    margin-right: 0.4rem;
    flex-shrink: 0;
  }
`;

const InlineInfoNote = ({ message, detail, className, pill, nowrap }) => {
  const icon = <Info size={14} color={colors.darkGray} />;
  return (
    <NoteContainer className={className} pill={pill} nowrap={nowrap}>
      {detail
        ? <Popup content={detail} position="bottom right" trigger={<span>{icon}</span>} />
        : icon}
      {message}
    </NoteContainer>
  );
};

InlineInfoNote.propTypes = {
  message: PropTypes.string.isRequired,
  detail: PropTypes.string,
  className: PropTypes.string,
  pill: PropTypes.bool,
  nowrap: PropTypes.bool
};

InlineInfoNote.defaultProps = {
  detail: undefined,
  className: undefined,
  pill: false,
  nowrap: false
};

export default InlineInfoNote;
